<script lang="ts">
  import { runningAsStandalone } from '$utils/runningAsStandalone';
  import Button from '$components/button/Button.svelte';
  import InstallPwaIos from '$modals/install-pwa-ios/InstallPwaIos.svelte';
  import InstallPwaAndroid from '$modals/install-pwa-android/InstallPwaAndroid.svelte';
  import { openModal } from '$components/bottom-sheet/index.svelte';
  import platform from 'platform';
  import { isInAppBrowser } from '$utils/detectInAppBrowser';
  import InAppBrowser from '$modals/in-app-browser/InAppBrowser.svelte';

  let standalone = $derived(runningAsStandalone());

  const openPWAPrompt = () => {
    if (isInAppBrowser()) {
      openModal(InAppBrowser);
    } else if (platform.os?.family === 'iOS') {
      openModal(InstallPwaIos);
    } else {
      openModal(InstallPwaAndroid);
    }
  };
</script>

{#if !standalone && !isInAppBrowser()}
  <div class="block pt-safe sm:hidden">
    <div
      class="relative z-10 grid grid-cols-[auto_1fr_auto] items-center gap-2 bg-background px-4 py-2">
      <div class="size-7 overflow-hidden rounded-lg">
        <img src="/metri/appIcons/256.png" alt="Metri" class="h-full w-full object-cover" />
      </div>
      <div class="grid typography-body-s-regular">
        <span class="typography-body-l-semibold">Metri</span>
        <span class="line-clamp-1 break-all">Add to homescreen</span>
      </div>
      <div>
        <Button ariaLabel="Install" testid="pwa-get-app-btn" size="xs" onclick={openPWAPrompt}
          >Get the App</Button>
      </div>
    </div>
  </div>
{/if}
